const VueMsg = {};

VueMsg.install = function (app) {
    app.mixin({
        beforeCreate() {
            this.$warn = function (msg) {
                this.$message({
                    message: msg,
                    type: "warning",
                });
            };
            this.$success = function (msg) {
                this.$message({
                    message: msg,
                    type: "success",
                });
            };
            this.$error = function (msg) {
                if (!msg) {
                    msg = "Error!";
                }
                this.$message.error(msg);
            };
            this.$showMsg = function (res) {
                if (!res) {
                    return;
                }
                let msg = this.$lang.getCodeMsg(res.Code);
                console.log("showMessage", msg);
                if (res.Code == 0) {
                    this.$success(msg);
                } else {
                    if (res.Code == 99002) {
                        msg = msg + res.Data;
                    }
                    if (!msg) {
                        msg = "Error!";
                    }
                    this.$error(msg);
                }
            };
            this.$myConfirm = function (options = {}) {
                let opt = {
                    title: "提示",
                    text: "确定执行该操作吗？",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    ...options,
                };
                return this.$confirm(opt.text, opt.title, {
                    confirmButtonText: opt.confirmButtonText,
                    cancelButtonText: opt.cancelButtonText,
                    type: "warning",
                });
            };
        },
    });
};

export default VueMsg;
